import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { getSociaMediaIcons, submitTemplate, updateTemplateDetail } from "../../../../utils/sociaMediaIconsApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import SocialIconsTemplateWidget from "../../../../components/Apps/SocialMediaIcons/Template/SocialIconsTemplateWidget";

//Import Tabs
import IconsTab from "../../../../components/Apps/SocialMediaIcons/IconsTab";
import LayoutTab from "../../../../components/Apps/SocialMediaIcons/LayoutTab";
import StyleTab from "../../../../components/Apps/SocialMediaIcons/StyleTab";

export default function CreateSocialMediaIcons() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Icons");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Social_Icons_Temp");
    const [selectedLayout, setSelectedLayout] = useState("social_icons_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("social-icons.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Social Media Icons");
    const [newWidgetName, setNewWidgetName] = useState("");
    const [isTemplateId, setTemplateId] = useState(null); 
    const [socialMediaIconIds, setSocialMediaIconIds] = useState([]);
    const [refreshWidgetList, setRefreshWidgetList] = useState(false);
    
    const [socialMediaIconsTabData, setSocialMediaIconsTabData] = useState({
        is_website_frontend: "",  
        icon_size: "32px",  
        location_type: "",   
        position_type: "",  
        social_custom_class: "",  
        icon_color: "", 
        background_color: "", 
        icon_color_on_hover: "", 
        background_color_on_hover: "", 
        icons_shape_type: "", 
        animation_type: "None", 
        opacity_size: 100, 
        opacity_on_hover_size: 100, 
        custom_css: "",   
        custom_js: "",   
    });

    // Set Template Setting And Texts when activeTemplateSection changes
        useEffect(() => {
            let location_type = "";
            let position_type = "";
            let social_custom_class = "";
            let icon_color = "";
            let background_color = "";
            let icon_color_on_hover = "";
            let background_color_on_hover = "";
            let icons_shape_type = "";
        
            switch (activeTemplateSection) {
                case "Social_Icons_Temp":
                    location_type = "inline";
                    position_type = "middle";
                    social_custom_class = "";
                    icon_color = "native";
                    background_color = "native";
                    icon_color_on_hover = "black";
                    background_color_on_hover = "white";
                    icons_shape_type = "circle";
                    break;
                case "Fixed_Icons_Temp":
                    location_type = "floating";
                    position_type = "left";
                    social_custom_class = "Fixed_Icons_Temp";
                    icon_color = "native";
                    background_color = "native";
                    icon_color_on_hover = "black";
                    background_color_on_hover = "white";
                    icons_shape_type = "";
                    break;
                case "Black_Icons_Temp":
                    location_type = "inline";
                    position_type = "middle";
                    social_custom_class = "";
                    icon_color = "#fff";
                    background_color = "#000";
                    icon_color_on_hover = "black";
                    background_color_on_hover = "white";
                    icons_shape_type = "";
                    break;
                case "White_Icons_Temp":
                    location_type = "inline";
                    position_type = "middle";
                    social_custom_class = "";
                    icon_color = "native";
                    background_color = "native";
                    icon_color_on_hover = "black";
                    background_color_on_hover = "white";
                    icons_shape_type = "";
                    break;
                case "Clean_Icons_Temp":
                    location_type = "inline";
                    position_type = "middle";
                    social_custom_class = "";
                    icon_color = "native";
                    background_color = "native";
                    icon_color_on_hover = "black";
                    background_color_on_hover = "white";
                    icons_shape_type = "";
                    break;
                case "More_Icons_Temp":
                    location_type = "inline";
                    position_type = "middle";
                    social_custom_class = "";
                    icon_color = "native";
                    background_color = "native";
                    icon_color_on_hover = "black";
                    background_color_on_hover = "white";
                    icons_shape_type = "";
                    break;
                default:
                    location_type = "";
                    position_type = "";
                    social_custom_class = "";
                    icon_color = "";
                    background_color = "";
                    icon_color_on_hover = "";
                    background_color_on_hover = "";
                    icons_shape_type = "";
            }
        
            // Update setSocialMediaIconsTabData state with the data
            setSocialMediaIconsTabData((prevData) => ({
                ...prevData,
                location_type: location_type,
                position_type: position_type,
                social_custom_class: social_custom_class,
                icon_color: icon_color,
                background_color: background_color,
                icon_color_on_hover: icon_color_on_hover,
                background_color_on_hover: background_color_on_hover,
                icons_shape_type: icons_shape_type,
            }));
        
        }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateSocialMediaIconsTabData = (key, value) => {
        setSocialMediaIconsTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = async () => {
        setShowTemplateSelection(false);
        
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            setSelectedLayout(layoutTypeValue);
        } else {
            alert('Please select a template');
        }

        //Call Api To Create Templates with dummy data first
        try {
            // Collect data from refs
            const settingsArray = Object.entries(socialMediaIconsTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                    name: widgetName,
                    template_name: activeTemplateSection,
                    template_image: selectedTemplateImage,
                    layout_name: selectedLayout,
                    layout_type: selectedLayout,
                    app_type: "Social_Media_Icons",
                    social_media_icon_ids: socialMediaIconIds,
                    settings: settingsArray,
            };
            
            //Api Call
            let api_response = await submitTemplate(payload);

            //Check Responce
            if (api_response.status === true) { 
                // Save templateId after first creation
                if (api_response.data.template_id) {
                   setTemplateId(api_response.data.template_id); 
                }

                setSocialMediaIconIds(api_response.data.social_media_icon_ids);
                setIsSubmitting(false); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        }
    }; 

    const menuItems = [
        { key: "Icons", icon: "icons.png", label: "Icons" },
        { key: "Layout", icon: "layout.png", label: "Layout" },
        { key: "Style", icon: "style.png", label: "Style" },
    ];

  // Handle Source Tab input change
  const handleActiveTemplateInputChange = (event) => {
      setActiveTemplateSection(event.target.value);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          const template_image = selectedRadio.dataset.template_image;
          setSelectedLayout(layoutTypeValue);
          setSelectedTemplateImage(template_image);
      } else {
          alert('Please select a template');
      }
  };

    // Fetch social media icons 
    useEffect(() => {
        const fetchIcons = async () => {
            try {
                const result = await getSociaMediaIcons();
                if(result?.status === true && Array.isArray(result?.data?.data_list)) {
                    const storeMediaIconIds = result.data.data_list.slice(1, 5).map((icon) => icon.id);
                    setSocialMediaIconIds(storeMediaIconIds);
                } else {
                    setSocialMediaIconIds([]);
                }
            } catch (error) {
                setSocialMediaIconIds([]);
            }
        };
        fetchIcons()
    }, []);

    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            // Convert settings object back into an array of key-value pairs
            const updateSettingsArray = Object.entries(socialMediaIconsTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: updateSettingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success("Submitted Successfully.");
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/social-media-icons');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        }
    };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Social Media Icons" app_type="Social_Media_Icons" app_slug="social-media-icons"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Social_Icons_Temp" data-layout_type="social_icons_layout" data-template_image="social-icons.png" checked={activeTemplateSection === "Social_Icons_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/social-media-icons/templates/social-icons.png`} alt="social-icons" />
                                    </div> 
                                    <div className="content_sub">Social Icons</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Fixed_Icons_Temp" data-layout_type="fixed_icons_layout" data-template_image="fixed-icons.png" checked={activeTemplateSection === "Fixed_Icons_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/social-media-icons/templates/fixed-icons.png`} alt="fixed-icons" />
                                    </div>
                                    <div className="content_sub">Fixed Icons</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Black_Icons_Temp" data-layout_type="black_icons_layout" data-template_image="black-icons.png" checked={activeTemplateSection === "Black_Icons_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/social-media-icons/templates/black-icons.png`} alt="black-icons" />
                                    </div>
                                    <div className="content_sub">Black Icons</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="White_Icons_Temp" data-layout_type="white_icons_layout" data-template_image="white-icons.png" checked={activeTemplateSection === "White_Icons_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/social-media-icons/templates/white-icons.png`} alt="white-icons" />
                                    </div>
                                    <div className="content_sub">White Icons</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Clean_Icons_Temp" data-layout_type="clean_icons_layout"  data-template_image="clean-icons.png" checked={activeTemplateSection === "Clean_Icons_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/social-media-icons/templates/clean-icons.png`} alt="clean-icons" />
                                    </div>
                                    <div className="content_sub">Clean Icons</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="More_Icons_Temp" data-layout_type="more_icons_layout" data-template_image="more-icons.png" checked={activeTemplateSection === "More_Icons_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/social-media-icons/templates/more-icons.png`} alt="more-icons" />
                                    </div>
                                    <div className="content_sub">More Icons</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/social-media-icons/icons/${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Icons" && (
                              <IconsTab isTemplateId={isTemplateId} setTemplateId={setTemplateId} updateSocialMediaIconsTabData={updateSocialMediaIconsTabData} socialMediaIconsTabData={socialMediaIconsTabData} setRefreshWidgetList={setRefreshWidgetList} />
                            )}
                            {activeSection === "Layout" && (
                              <LayoutTab updateSocialMediaIconsTabData={updateSocialMediaIconsTabData} socialMediaIconsTabData={socialMediaIconsTabData}/>
                            )}
                            {activeSection === "Style" && (
                              <StyleTab updateSocialMediaIconsTabData={updateSocialMediaIconsTabData} socialMediaIconsTabData={socialMediaIconsTabData} />
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/social-media-icons"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/social-media-icons/social-media-icons.svg`} alt="social-media-icons"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/social-media-icons/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/social-media-icons" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Social Media Icons <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Call Common Widget*/}
                    <SocialIconsTemplateWidget isTemplateId={isTemplateId} socialMediaIconsTabData={socialMediaIconsTabData} refreshWidgetList={refreshWidgetList} />
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 